"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.faq = void 0;
var react_1 = __importDefault(require("react"));
exports.faq = [
    {
        title: 'Jak vyhledám znalce, znaleckou kancelář, znalecký ústav?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "V r\u00E1mci vyhled\u00E1vac\u00EDho formul\u00E1\u0159e na z\u00E1lo\u017Ece Znalci vypl\u0148te n\u011Bkter\u00FD z libovoln\u00FDch \u00FAdaj\u016F a klikn\u011Bte na tla\u010D\u00EDtko ",
                react_1.default.createElement("b", null, "Vyhledat"),
                ", p\u0159\u00EDpadn\u011B stiskn\u011Bte kl\u00E1vesu ",
                react_1.default.createElement("b", null, "Enter"),
                ". Formul\u00E1\u0159 m\u016F\u017Eete nechat i pr\u00E1zdn\u00FD. Po zobrazen\u00ED v\u00FDsledk\u016F klikn\u011Bte na jm\u00E9no \u010Di n\u00E1zev osoby pro zobrazen\u00ED detailu."))),
    },
    {
        title: 'Jak vyhledám tlumočníka nebo překladatele?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "V r\u00E1mci vyhled\u00E1vac\u00EDho formul\u00E1\u0159e na z\u00E1lo\u017Ece ",
                react_1.default.createElement("b", null, "Tlumo\u010Dn\u00EDci"),
                " vypl\u0148te n\u011Bkter\u00FD z libovoln\u00FDch \u00FAdaj\u016F a klikn\u011Bte na tla\u010D\u00EDtko ",
                react_1.default.createElement("b", null, "Vyhledat"),
                ", p\u0159\u00EDpadn\u011B stiskn\u011Bte kl\u00E1vesu",
                ' ',
                react_1.default.createElement("b", null, "Enter"),
                ". Formul\u00E1\u0159 m\u016F\u017Eete nechat i pr\u00E1zdn\u00FD. Po zobrazen\u00ED v\u00FDsledk\u016F klikn\u011Bte na jm\u00E9no \u010Di n\u00E1zev osoby pro zobrazen\u00ED detailu."))),
    },
    {
        title: 'Jak zjistím, který znalec pracuje pro konkrétní kancelář či ústav?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null, "Informace o \u010Dlenstv\u00ED znalc\u016F v kancel\u00E1\u0159\u00EDch je dostupn\u00E1 na profilu osoby znalce \u010Di kancel\u00E1\u0159e. Informace o \u010Dlenstv\u00ED znalc\u016F ve znaleck\u00FDch \u00FAstavech je dostupn\u00E1 pouze na profilu znaleck\u00E9ho \u00FAstavu."))),
    },
    {
        title: 'Jak vyhledám znalce na základě oboru, odvětví či specializace znalecké činnosti?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "Ve vyhled\u00E1vac\u00EDm formul\u00E1\u0159i zvolte konkr\u00E9tn\u00ED znaleck\u00FD obor, odv\u011Btv\u00ED \u010Di specializaci z nab\u00EDzen\u00E9ho rozsahu a n\u00E1sledn\u011B potvr\u010Fte kliknut\u00EDm na tla\u010D\u00EDtko ",
                react_1.default.createElement("b", null, "Vyhledat"),
                " \u010Di stisknut\u00EDm kl\u00E1vesy ",
                react_1.default.createElement("b", null, "Enter"),
                "."))),
    },
    {
        title: 'Jak vyhledám tlumočníka či překladatele na základě jazyka a specializace?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "Ve vyhled\u00E1vac\u00EDm formul\u00E1\u0159i zvolte jazyk a specializaci z nab\u00EDzen\u00E9ho rozsahu a n\u00E1sledn\u011B potvr\u010Fte kliknut\u00EDm na tla\u010D\u00EDtko ",
                react_1.default.createElement("b", null, "Vyhledat"),
                " \u010Di stisknut\u00EDm kl\u00E1vesy ",
                react_1.default.createElement("b", null, "Enter"),
                "."))),
    },
    {
        title: 'Jak vyhledám osobu znalce či tlumočníka na základě soudního kraje, okresu či obce?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "Ve vyhled\u00E1vac\u00EDm formul\u00E1\u0159i zvolte p\u0159\u00EDslu\u0161n\u00FD kraj, okres \u010Di p\u0159\u00EDpadn\u011B obec z nab\u00EDzen\u00E9ho rozsahu a n\u00E1sledn\u011B potvr\u010Fte kliknut\u00EDm na tla\u010D\u00EDtko ",
                react_1.default.createElement("b", null, "Vyhledat"),
                " \u010Di stisknut\u00EDm kl\u00E1vesy ",
                react_1.default.createElement("b", null, "Enter"),
                "."))),
    },
    {
        title: 'Mohu v seznamech naleznout i osoby s pozastaveným či zaniklým oprávněním?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "Osoby se zanikl\u00FDm nebo pozastaven\u00FDm opr\u00E1vn\u011Bn\u00EDm lze jednodu\u0161e dohledat v r\u00E1mci v\u00FDsledk\u016F vyhled\u00E1v\u00E1n\u00ED. Klikn\u011Bte na jedno ze za\u0161krt\u00E1vac\u00EDch pol\u00ED\u010Dek v z\u00E1hlav\u00ED v\u00FDsledk\u016F vyhled\u00E1v\u00E1n\u00ED ",
                react_1.default.createElement("b", null, "Zobrazit i osoby s pozastavenou \u010Dinnost\u00ED"),
                " nebo ",
                react_1.default.createElement("b", null, "Zobrazit i osoby se z\u00E1nikem opr\u00E1vn\u011Bn\u00ED"),
                ". Syst\u00E9m do v\u00FDsledk\u016F zahrne i pr\u00E1v\u011B tyto osoby."))),
    },
    {
        title: 'Jak získám výpis konkrétního znalce/tlumočníka? Najdu v něm všechna oprávnění, přestupky, pozastavení činnosti apod.?',
        content: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null),
            react_1.default.createElement("p", null,
                "V\u00FDpis ze syst\u00E9mu znalc\u016F a tlumo\u010Dn\u00EDk\u016F lze prov\u00E9st na profilu dan\u00E9 osoby. Zobrazte detail vyhledan\u00E9 osoby, klikn\u011Bte na tla\u010D\u00EDtko ",
                react_1.default.createElement("b", null, "V\u00FDpis"),
                " v prav\u00E9 horn\u00ED \u010D\u00E1sti obrazovky a zvolte jeden z dostupn\u00FDch typ\u016F v\u00FDpisu. Po kliknut\u00ED dojde ke sta\u017Een\u00ED v\u00FDpisu ve form\u00E1tu PDF."))),
    },
];
